export enum DeviceType {
    PC = 'pc',
    MO = 'mobile'
  }